import React from 'react';
import { motion } from 'framer-motion';
export function CostTable() {
  const data = [{
    sin: 'Omeprazol de por vida sin plan de salida',
    costo: 'Deficiencias de B12, Magnesio y Zinc acumulándose'
  }, {
    sin: 'Noches interrumpidas por el ardor',
    costo: 'Sueño fragmentado que amplifica la fatiga y la ansiedad'
  }, {
    sin: 'Restricciones sin estrategia',
    costo: 'Eliminar tomate y café sin que el ardor mejore igual'
  }, {
    sin: 'Tos crónica sin diagnóstico correcto',
    costo: 'Años de jarabes que tratan el humo sin apagar el fuego'
  }, {
    sin: 'Otro año con el mismo ardor',
    costo: 'El mismo fuego. La misma pastilla. El año que viene.'
  }];
  return <section className="py-24 bg-brand-dark" data-id="element-70">
      <div className="container mx-auto px-4" data-id="element-71">
        <div className="max-w-4xl mx-auto" data-id="element-72">
          <div className="text-center mb-12" data-id="element-73">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-gold font-[Poppins,_sans-serif]" data-id="element-74">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>

          <div className="bg-[#0a2a1a] rounded-2xl border border-[#1a4a2e] overflow-hidden mb-16" data-id="element-75">
            {data.map((row, i) => <div key={i} className="border-b border-[#1a4a2e] last:border-0" data-id="element-76">
                <div className="border-l-4 border-[#2d6b45] px-5 py-4 bg-[#0d2f1e]" data-id="element-77">
                  <p className="text-sm md:text-base font-[700] text-[#FFFFFF]" data-id="element-78">
                    ❌ {row.sin}
                  </p>
                </div>
              </div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-79">
            <p className="text-2xl font-bold text-white mb-6" data-id="element-80">
              El próximo lunes puede ser diferente.
            </p>
            <p className="text-xl md:text-3xl font-bold text-brand-light italic font-[Poppins,_sans-serif]" data-id="element-81">
              "Tu esófago no está roto. Solo estaba esperando el mapa correcto."
              🌿
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}